import { render, staticRenderFns } from "./templateAutoresponder.vue?vue&type=template&id=d20b3e86&scoped=true&"
import script from "./templateAutoresponder.vue?vue&type=script&lang=js&"
export * from "./templateAutoresponder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20b3e86",
  null
  
)

export default component.exports